import { AxiosResponse } from 'axios';

import { CreateTimeCodeRequestType, FetchTimeCodesRequestType } from './types';

import { CommonResponseType } from 'api/authApi';
import { GeneralResponseType } from 'common';
import { authServiceClient } from 'config';
import { TimeCodeType } from 'state';

export const fetchTimeCodesRequest = (params: FetchTimeCodesRequestType) => {
  return authServiceClient.get<
    GeneralResponseType<TimeCodeType>,
    AxiosResponse<GeneralResponseType<TimeCodeType>>,
    FetchTimeCodesRequestType
  >(`/timecode`, { params });
};

export const createTimeCodeRequest = (data: CreateTimeCodeRequestType) => {
  return authServiceClient.post<
    TimeCodeType,
    AxiosResponse<TimeCodeType>,
    CreateTimeCodeRequestType
  >(`/timecode`, data);
};

export const deleteTimeCodeRequest = (id: string) => {
  return authServiceClient.delete<CommonResponseType, AxiosResponse<CommonResponseType>>(
    `/timecode/${id}`,
  );
};

export const editTimeCodeRequest = (
  timeCode: Omit<CreateTimeCodeRequestType, 'fileId'> & { id: string },
) => {
  return authServiceClient.put<
    CommonResponseType,
    AxiosResponse<CommonResponseType>,
    Omit<CreateTimeCodeRequestType, 'fileId'>
  >(`/timecode/${timeCode.id}`, timeCode);
};
